import React from 'react';
import {
  SubNavigationNavBar,
  SmallSubNavigationNavBar,
} from './SubNavigationNavBar';
import { AltSubNavigationNavLink } from './AltSubNavigationNavItem';
import { SubNavigationNavLink } from './SubNavigationNavItem';
import {
  AltSubNavigationNavBar,
  AltSmallSubNavigationNavBar,
} from './AltSubNavigationNavBar';

const SubNavigation = ({
  small = false,
  routes,
  id = 'subnavigation',
  params,
  currentSearch,
  isUnlimitedPlan = false,
  ...props
}) => {
  const SubNavBar = small ? SmallSubNavigationNavBar : SubNavigationNavBar;
  return (
    <SubNavBar id={id} {...props}>
      {Object.entries(routes).map(([key, route], index, arr) => {
        if (route.access?.hideFromNav) {
          return null;
        }

        if (
          typeof route.access?.allowedByPlan === 'function' &&
          !route.access.allowedByPlan({ isUnlimitedPlan })
        ) {
          return null;
        }

        return (
          <React.Fragment key={index}>
            <SubNavigationNavLink
              numberOfLinks={arr.length}
              isLast={index === arr.length - 1}
              params={params}
              currentSearch={currentSearch}
              small={small}
              route={route}
              key={key}
            />
          </React.Fragment>
        );
      })}
    </SubNavBar>
  );
};

export const AltSubNavigation = ({
  small = false,
  routes,
  id = 'subnavigation',
  params,
  ...props
}) => {
  const SubNavBar = small
    ? AltSmallSubNavigationNavBar
    : AltSubNavigationNavBar;

  return (
    <SubNavBar className="alt" id={id} {...props}>
      {Object.entries(routes).map(([key, route], index, arr) => (
        <React.Fragment key={index}>
          <AltSubNavigationNavLink
            className={
              index === 0 && arr.length === 3 ? 'alt firstOfThree' : 'alt'
            }
            isLast={index === arr.length - 1}
            numberOfLinks={arr.length}
            key={key}
            route={route}
            small={small}
            params={params}
          />
        </React.Fragment>
      ))}
    </SubNavBar>
  );
};

export default SubNavigation;
